export default __webpack_public_path__ + "static/media/test-camera.d9299252.svg";